import { Navigate, createBrowserRouter } from "react-router";
import LogoutPage from "@/pages/Logout";
import LoginPage from "@/pages/Login";
import InitRoot from "@/InitRoot";
import { APP_ROUTES } from "@/utils";
import OAuthCallbackPage from "@/pages/OAuthCallbackPage";
import HomeWrapper from "@/pages/Home/Wrapper";
import HomeOverviewPage from "@/pages/Home/Overview";
import PayChoosePlan from "./pages/Pay/ChoosePlan";
import PayGetOrder from "./pages/Pay/GetOrder";
import HomeProfilePage from "./pages/Home/Profile";
import HomeProfileAccountPage from "./pages/Home/Profile/Account";
import KuknosPaymentCallbackPage from "./pages/Pay/KuknosPaymentCallback";
import EpaPaymentCallbackPage from "./pages/Pay/EpaPaymentCallback";
import PrePayCallback from "./pages/Pay/PrePayCallback";
import PurchaseHistoryPage from "./pages/Home/PurchaseHistory";
import OrderDetailsPage from "./pages/Home/OrderDetails";
import InstallmentVerifyCallbackPage from "./pages/Pay/InstallmentVerifyCallback";
import HomeInstallmentDetailsPage from "./pages/Home/Installment";
import PaymentHistoryPage from "./pages/Home/PaymentHistory";
import PaySetPlanPage from "./pages/Pay/SetPlan";
import HomeLayout from "./pages/Home/Layout";
import PayLayout from "./pages/Pay/Layout";

const getChildPath = (path: string, depth: number) => {
  const arr = path.split("/");
  arr.splice(0, depth);
  return arr.join("/");
};

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    element: <InitRoot />,
    children: [
      {
        element: <LoginPage />,
        path: APP_ROUTES.login.url,
      },
      {
        element: <LogoutPage />,
        path: APP_ROUTES.logout.url,
      },
      {
        element: <OAuthCallbackPage />,
        path: APP_ROUTES.oAuthCallback.url,
      },
      {
        element: <PayGetOrder />,
        path: APP_ROUTES.pay.getOrder.root.url,
      },
      {
        element: <KuknosPaymentCallbackPage />,
        path: APP_ROUTES.pay.kuknospaymentCallback.root.url,
      },
      {
        element: <EpaPaymentCallbackPage />,
        path: APP_ROUTES.pay.epapaymentCallback.root.url,
      },
      {
        element: <PayLayout />,
        path: APP_ROUTES.pay.root.url,
        children: [
          {
            element: <PayChoosePlan />,
            path: getChildPath(APP_ROUTES.pay.choosePlan.url, 2),
          },
          {
            element: <PaySetPlanPage />,
            path: getChildPath(APP_ROUTES.pay.setPlan.url, 2),
          },
          {
            element: <PrePayCallback />,
            path: getChildPath(APP_ROUTES.pay.prepayCallback.root.url, 2),
          },
          {
            element: <InstallmentVerifyCallbackPage />,
            path: getChildPath(APP_ROUTES.pay.installmentVerifyCallback.root.url, 2),
          },
          {
            element: <Navigate to={APP_ROUTES.home.overview.url} replace />,
            path: "*",
          },
        ],
      },
      {
        element: <HomeLayout />,
        children: [
          {
            element: (
              <HomeWrapper>
                <HomeOverviewPage />
              </HomeWrapper>
            ),
            path: getChildPath(APP_ROUTES.home.overview.url, 1),
          },
          {
            element: (
              <HomeWrapper>
                <PaymentHistoryPage />
              </HomeWrapper>
            ),
            path: getChildPath(APP_ROUTES.home.paymentHistory.url, 1),
          },
          {
            element: (
              <HomeWrapper>
                <PurchaseHistoryPage />
              </HomeWrapper>
            ),
            path: getChildPath(APP_ROUTES.home.purchaseHistory.url, 1),
          },
          {
            element: (
              <HomeWrapper>
                <OrderDetailsPage />
              </HomeWrapper>
            ),
            path: getChildPath(APP_ROUTES.home.orderDetail.url, 1),
          },
          {
            element: <HomeInstallmentDetailsPage />,
            path: getChildPath(APP_ROUTES.home.installmentDetails.url, 1),
          },
          {
            element: (
              <HomeWrapper>
                <HomeProfilePage />
              </HomeWrapper>
            ),
            path: getChildPath(APP_ROUTES.home.profile.root.url, 1),
          },
          {
            element: (
              <HomeWrapper>
                <HomeProfileAccountPage />
              </HomeWrapper>
            ),
            path: getChildPath(APP_ROUTES.home.profile.account.url, 1),
          },

          {
            element: <Navigate to={APP_ROUTES.home.overview.url} replace />,
            path: "*",
          },
        ],
      },
      // {
      //   element: <Navigate to={APP_ROUTES.home.overview.url} replace />,
      //   path: "*",
      // },
    ],
  },
]);
